export default {
	methods: {
		formatCurrency: (money) => {
			const formattedMoney = new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
				maximumFractionDigits: 2,
			}).format(money);
		
			return formattedMoney.replace(/\.00$/, "");
		},
		displayDuration: (duration) => {
      const minutes = Math.floor(duration / 60);
      return `${minutes} Menit`;
    },
	}
}